import { Edit, ListButton, TopToolbar } from 'react-admin';
import ChevronLeft from '@material-ui/icons/ChevronLeft';

import ApplicationReasonForm from './ApplicationReasonForm';

const ApplicationReasonActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const ApplicationReasonEdit = (props: any) => {
  return (
    <Edit actions={<ApplicationReasonActions {...props} />} {...props}>
      <ApplicationReasonForm />
    </Edit>
  );
};

export default ApplicationReasonEdit;
